const STORAGE_KEY = "redo_localization_enabled";

class LocalizationConfig {
  private enabled: boolean;
  private readonly listeners = new Set<() => void>();

  constructor() {
    this.enabled = this.readFromStorage();
  }

  isEnabled = (): boolean => {
    return this.enabled;
  };

  /** For `useSyncExternalStore`, so UI gated on the flag re-renders when it flips. */
  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  setEnabled(enabled: boolean): void {
    const changed = this.enabled !== enabled;
    this.enabled = enabled;
    this.writeToStorage(enabled);
    if (changed) {
      for (const listener of this.listeners) {
        listener();
      }
    }
  }

  private readFromStorage(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch {
      return false;
    }
  }

  private writeToStorage(enabled: boolean): void {
    try {
      localStorage.setItem(STORAGE_KEY, String(enabled));
    } catch {
      // localStorage may not be available
    }
  }
}

export const localizationConfig = new LocalizationConfig();
